/* RESPONSIBLE TEAM: team-reporting */
import ApplicationAdapter from 'embercom/adapters/application';

export default class DatasetExportScheduleAdapter extends ApplicationAdapter {
  pathForType() {
    return 'reporting/scheduled_export';
  }
}
